import { faCopy } from "@fortawesome/duotone-light-svg-icons"
import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonColorExpanded, JoonUIColor, Typography } from "@joonapp/web-shared"
import { useState } from "react"

import { useChildAuthCodeQuery } from "../../networking/queries"

const ChildAuthCode2 = () => {
  const { data: authCode } = useChildAuthCodeQuery()
  const [isCopied, setIsCopied] = useState(false)

  const copyAuthCode = () => {
    if (!authCode) return
    navigator.clipboard.writeText(authCode)
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 1000)
  }

  return (
    <div className="flex flex-row gap-2 items-center w-full bg-indigo-100 rounded-md px-3 py-2">
      <Typography
        variant="bodyBold"
        color={JoonColorExpanded.indigo700}
        className="whitespace-nowrap"
      >
        Child Login Code:{" "}
      </Typography>
      <div className="flex  relative w-full">
        <button onClick={copyAuthCode} className="w-full">
          <div className="flex flex-row items-center gap-2 justify-between w-full">
            <Typography variant="bodyBold" style={{ userSelect: "text" }}>
              {authCode}
            </Typography>
            <FontAwesomeIcon
              icon={isCopied ? faCheck : faCopy}
              fontSize={16}
              color={
                isCopied
                  ? JoonUIColor.semantic.success
                  : JoonUIColor.text.primaryAccent
              }
            />
          </div>
        </button>
      </div>
    </div>
  )
}

export default ChildAuthCode2
